<template>
  <div v-if="!pending" class="tailwind">
    <UpsellingSliderWidget
      :booking="properties.booking"
      :width="properties.width"
      :slidesPerView="4"
      :onSliderClick="redirect"
      :onSlideClick="redirect"
      :onApplyUpsell="redirect"
      :preview="'single'"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { UpsellingSliderWidget, useUrlRoot } from '@common/lib-vue-common'
import { startUpLabels } from './composables/useLabels.js'

const properties = window.appGlobalProps.upsellingSlider

const redirect = () => {
  const preArrivalToken = encodeURIComponent(properties?.booking?.preArrivalToken)
  const url = `${useUrlRoot()}/reservation/upselling?token=${preArrivalToken}`
  window.location.href = url
}

const pending = ref(true)
onMounted(async () => {
  await startUpLabels()
  pending.value = false
})
</script>
